// extracted by mini-css-extract-plugin
export default {"wishBtn":"wishBtn_wishBtn__ScZp7"};